import { ChannelPostType } from "../models/post"

export const getChannelIds = (channels: ChannelPostType[]) => {
  const channelIds = channels.map(({ channel }) => channel?.id)
  return channelIds.filter(id => !!id).map(String)
}
